import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'

export function HowWeScore() {
  return (
    <Accordion
      type="single"
      collapsible
      className="rounded-xl border border-border bg-card px-5"
    >
      <AccordionItem value="scoring" className="border-0">
        <AccordionTrigger className="py-4 hover:no-underline">
          <span>
            <span className="block font-semibold">How we score visibility</span>
            <span className="mt-0.5 block text-xs font-normal text-muted-foreground">
              See why your rate and weighted score can tell different stories.
            </span>
          </span>
        </AccordionTrigger>
        <AccordionContent className="space-y-3 pb-5 text-muted-foreground">
          <p>
            <strong className="text-foreground">Visibility rate</strong> is the
            share of generated queries where your brand appeared in at least one
            active AI model.
          </p>
          <p>
            <strong className="text-foreground">Weighted score</strong> starts
            with 10 points for a direct mention or 5 for an indirect mention,
            then applies a rank discount (1 / log₂(position + 1)) and a tone
            weight (positive 1.0, neutral 0.7, negative 0.2). Your total is
            compared with the maximum possible across every completed query and
            model.
          </p>
          <p>
            A high rate with a lower score usually means your brand appears
            often, but less directly, lower in the answer, or with weaker
            sentiment.
          </p>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  )
}
